function updateCheckingOut() {
      // Generate a random number between 11 and 30
      const randomNumber = Math.floor(Math.random() * (30 - 11 + 1)) + 11;
      document.getElementById('checking-out').textContent = `${randomNumber} others are checking out`;
}

updateCheckingOut();